import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
window.Vue = require("vue");

import ExampleComponent from "./components/ExampleComponent.vue";
import Home from "./components/Home.vue";

//Default Ends
import NotFound from "./components/404.vue";
import AccessDenied from "./components/AccessDenied.vue";
import NoData from "./components/NoData.vue";
// import Passport from './components/Passport.vue'

Vue.component("NotFound", require("./components/404.vue").default);
Vue.component("AccessDenied", require("./components/AccessDenied.vue").default);
Vue.component("NoData", require("./components/NoData.vue").default);
Vue.component(
    "LogoPrint",
    require("./components/LogoForPrintMaterial.vue").default
);

// SysAdmin Vues
import Notifications from "./components/views/system/Notifications.vue";
import NotificationManager from "./components/views/system/NotificationManager.vue";
import CreateNotifications from "./components/views/system/CreateNotifications.vue";
import SysAdminManageUsers from "./components/views/system/SystemUsers.vue";
import SysAdminManageMasterCompanies from "./components/views/masters/Companies.vue";
import SysAdminManageMasterBranches from "./components/views/masters/Branches.vue";
import SysAdminManageMasterEmployees from "./components/views/hr/ERPEmployees.vue";
import SysAdminManageMasterWarehouses from "./components/views/masters/Warehouses.vue";
import SysAdminManageMasterPaymentModes from "./components/views/masters/PaymentModes.vue";
import SysAdminManageMasterFinanceModes from "./components/views/masters/FinanceModes.vue";
import SysAdminManageMasterTaxCodes from "./components/views/masters/TaxCodes.vue";
import SysAdminManageMasterZones from "./components/views/masters/Zones.vue";
import SysAdminManageBranches from "./components/views/masters/AltBranches.vue";
import BranchAccounts from "./components/views/masters/BranchAccounts.vue";
import SysAdminManageLedgerAccounts from "./components/views/masters/LedgerAccounts.vue";
import SysAdminManageStoreStock from "./components/views/erp-reports/AltStoreStock.vue";
import SysAdminManageSalesmen from "./components/views/masters/Salesmen.vue";
import SysAdminManageCustomers from "./components/views/masters/Leads.vue";
import SysAdminCustomerProfile from "./components/views/masters/CustomerProfile.vue";
import SysAdminManageDivisionLists from "./components/views/masters/DivisionLists.vue";
import SysAdminManageCategoryLists from "./components/views/masters/CategoryLists.vue";
import SysAdminManageProductLists from "./components/views/masters/ProductLists.vue";
import SysAdminManageBrandsLists from "./components/views/masters/Brands.vue";
import SysAdminManageStatusLists from "./components/views/masters/ConfigurationItems.vue";
import SysAdminManageModes from "./components/views/masters/Modes.vue";
import SysAdminManageDeliveryPartners from "./components/views/delivery/ManageDeliveryPartners.vue";
import SysAdminManageDrivers from "./components/views/delivery/ManageDrivers.vue";
import SysAdminManageVehicles from "./components/views/delivery/ManageVehicles.vue";
import SysAdminManageAddOnServices from "./components/views/masters/AddOnServices.vue";
import SysAdminManageCampaignConfig from "./components/views/marketing/CampaignConfig.vue";
import SysAdminManageBuybackRules from "./components/views/masters/BuybackRules.vue";
import SysAdminWarehouseLinkages from "./components/views/masters/WarehouseLinkages.vue";
import SysAdminManageDivisionCategoryLinks from "./components/views/masters/DivisionCategoryLinks.vue";
import SysAdminManageCategoryProductLinks from "./components/views/masters/CategoryProductLinks.vue";
import SysAdminManageMasterDeliveryRoutes from "./components/views/delivery/DeliveryRoutes.vue";
import SysAdminManageMasterDeliveryItemConfig from "./components/views/delivery/DeliveryItemConfig.vue";
import SysAdminManageMasterServiceCallOrigins from "./components/views/masters/ServiceCallOrigins.vue";
import SysAdminManageMasterServiceCallTypes from "./components/views/masters/ServiceCallTypes.vue";
import SysAdminManageMasterServiceProblemTypes from "./components/views/masters/ServiceProblemTypes.vue";
import SysAdminManageMasterServiceProblemSubTypes from "./components/views/masters/ServiceProblemSubTypes.vue";
import BankOffers from "./components/views/masters/BankOffers.vue";
import SpecialOffers from "./components/views/masters/SpecialOffers.vue";
import SysAdminAppPassport from "./components/views/system/Passport.vue";
import TermsOfSales from "./components/views/sales/TermsOfSales.vue";
import TermsOfService from "./components/views/servicing/TermsOfService.vue";
import TermsOfPurchase from "./components/views/purchasing/TermsOfPurchase.vue";
import AdminSettings from "./components/views/sys-admin/Settings.vue";

// Service Agent
import ServiceAgentAddJob from "./components/views/service-agent/AddJob.vue";

import ServiceAgentAddWalkin from "./components/views/service-agent/AddWalkin.vue";
import ServiceAgentWalkinReport from "./components/views/service-agent/WalkinReport.vue";
import ServiceAgentTrackJobStatus from "./components/views/service-agent/TrackJobStatus.vue";

// Service Tech
import ServiceTechJobStatus from "./components/views/service-tech/JobStatus.vue";
import ServiceTechJobStatusUpdates from "./components/views/service-tech/JobStatusUpdates.vue";
import ServiceTechMyPerformance from "./components/views/service-tech/MyPerformance.vue";
import ServiceTechPartRequests from "./components/views/service-tech/PartRequests.vue";

// Service Manager
import ServiceManagerAddJob from "./components/views/service-manager/AddJob.vue";
import ServiceManagerAddItem from "./components/views/service-manager/AddItem.vue";
import ServiceManagerAddExpense from "./components/views/service-manager/AddExpense.vue";
import ServiceManagerItemData from "./components/views/service-manager/ItemData.vue";
import ServiceManagerJobStatus from "./components/views/service-manager/JobStatus.vue";
import ServiceManagerNetProfit from "./components/views/service-manager/NetProfit.vue";
import ServiceManagerGrossProfit from "./components/views/service-manager/GrossProfit.vue";
import ServiceManagerAgentPerformanceReport from "./components/views/service-manager/AgentPerformanceReport.vue";
import ServiceManagerManageEmployees from "./components/views/service-manager/ManageEmployees.vue";
import ServiceManagerManageEmployeeReview from "./components/views/service-manager/ManageEmployeeReview.vue";
import ServiceManagerEmployeeProfile from "./components/views/service-manager/EmployeeProfile.vue";
import ServiceManagerManageInventory from "./components/views/service-manager/ManageInventory.vue";
import ServiceManagerCollectedAmounts from "./components/views/service-manager/CollectedAmounts.vue";
import ServiceManagerAddWalkin from "./components/views/service-manager/AddWalkin.vue";
import ServiceManagerWalkinReport from "./components/views/service-manager/WalkinReport.vue";

// Replacement Manager
import ReplacementManagerAddJob from "./components/views/replacement-manager/AddJob.vue";
import ReplacementManagerJobStatus from "./components/views/replacement-manager/JobStatus.vue";
import ReplacementManagerFinancialReport from "./components/views/replacement-manager/FinancialReport.vue";
import ReplacementManagerAgentPerformanceReport from "./components/views/replacement-manager/AgentPerformanceReport.vue";
import ReplacementManagerManageEmployees from "./components/views/replacement-manager/ManageEmployees.vue";
import ReplacementManagerEmployeeProfile from "./components/views/replacement-manager/EmployeeProfile.vue";
import ReplacementManagerManageInventory from "./components/views/replacement-manager/ManageInventory.vue";

// DOA Manager
import DOAManagerAddJob from "./components/views/doa-manager/AddJob.vue";
import DOAManagerJobStatus from "./components/views/doa-manager/JobStatus.vue";
import DOAManagerFinancialReport from "./components/views/doa-manager/FinancialReport.vue";
import DOAManagerAgentPerformanceReport from "./components/views/doa-manager/AgentPerformanceReport.vue";
import DOAManagerManageEmployees from "./components/views/doa-manager/ManageEmployees.vue";
import DOAManagerEmployeeProfile from "./components/views/doa-manager/EmployeeProfile.vue";
import DOAManagerManageInventory from "./components/views/doa-manager/ManageInventory.vue";

// Extended Warranty Admim
import ExtWarrAdminAddJob from "./components/views/ext-warr-admin/AddJob.vue";
import ExtWarrAdminJobStatus from "./components/views/ext-warr-admin/JobStatus.vue";
import ExtWarrAdminFinancialReport from "./components/views/ext-warr-admin/FinancialReport.vue";
import ExtWarrAdminAgentPerformanceReport from "./components/views/ext-warr-admin/AgentPerformanceReport.vue";
import ExtWarrAdminManageEmployees from "./components/views/ext-warr-admin/ManageEmployees.vue";
import ExtWarrAdminEmployeeProfile from "./components/views/ext-warr-admin/EmployeeProfile.vue";
import ExtWarrAdminManageInventory from "./components/views/ext-warr-admin/ManageInventory.vue";

// Service Admin

import ServiceAdminJobStatus from "./components/views/service-admin/JobStatus.vue";
import ServiceAdminAddExpense from "./components/views/service-admin/AddExpense.vue";
import ServiceAdminNetProfit from "./components/views/service-admin/NetProfit.vue";
import ServiceAdminGrossProfit from "./components/views/service-admin/GrossProfit.vue";
import ServiceAdminAgentPerformanceReport from "./components/views/service-admin/AgentPerformanceReport.vue";
import ServiceAdminManageEmployees from "./components/views/service-admin/ManageEmployees.vue";
import ServiceAdminEmployeeProfile from "./components/views/service-admin/EmployeeProfile.vue";
import ServiceAdminCollectedAmounts from "./components/views/service-admin/CollectedAmounts.vue";
import ServiceAdminBranchwiseDailyFinancialReport from "./components/views/service-admin/BranchwiseDailyFinancialReport.vue";
import ServiceAdminBranchwiseGrossProfitReport from "./components/views/service-admin/BranchwiseGrossProfitReport.vue";
import ServiceAdminBranchwiseItemCategoryCounts from "./components/views/service-admin/BranchwiseItemCategoryCounts.vue";
import ServiceAdminBranchwiseJobCategoryCounts from "./components/views/service-admin/BranchwiseJobCategoryCounts.vue";
import ServiceAdminBranchwiseNetProfitReport from "./components/views/service-admin/BranchwiseNetProfitReport.vue";
import ServiceAdminAnnualBranchwiseNetProfitReport from "./components/views/service-admin/AnnualBranchwiseNetProfitReport.vue";
import ServiceAdminAnnualBranchwiseGrossProfitReport from "./components/views/service-admin/AnnualBranchwiseGrossProfitReport.vue";
import ServiceAdminAddItem from "./components/views/service-admin/AddItem.vue";
import ServiceAdminManageInventory from "./components/views/service-admin/ManageInventory.vue";
import ServiceAdminManageEmployeeReview from "./components/views/service-admin/ManageEmployeeReview.vue";
import ServiceAdminItemData from "./components/views/service-admin/ItemData.vue";
import ServiceAdminWalkinReport from "./components/views/service-admin/WalkinReport.vue";

// Purchase Manager
import PurchaseManagerAddItem from "./components/views/purchase-manager/AddItem.vue";
import PurchaseManagerManageInventory from "./components/views/purchase-manager/ManageInventory.vue";
import PurchaseManagerItemData from "./components/views/purchase-manager/ItemData.vue";
import PurchaseManagerPurchaseOrder from "./components/views/purchase-manager/PurchaseOrder.vue";
import PurchaseManagerItemRequests from "./components/views/purchase-manager/ItemRequests.vue";
import PurchaseManagerRequestData from "./components/views/purchase-manager/RequestData.vue";

//Zonal Manager
import ZonalManagerStockTransferRequests from "./components/views/stock-transfer/ManageStockTransferRequests.vue";

//Expense Admin
import RequestPettyCash from "./components/views/expensing/RequestPettyCash.vue";
import ExpenseRequestsReport from "./components/views/expensing/ExpenseRequestsReport.vue";
import PendingExpenseRequests from "./components/views/expensing/PendingExpenseRequests.vue";

// User
import UserTrackJob from "./components/views/user/TrackJobStatus.vue";
import UserJobProfile from "./components/views/user/JobProfile.vue";
import UserJobSheetBrief from "./components/views/user/JobSheetBrief.vue";

//Common Routes
import DailyStats from "./components/views/reports/DailyStats.vue";
import MonthlyStats from "./components/views/reports/MonthlyStats.vue";
import Gatepasses from "./components/views/sales/Gatepasses";
import GatepassDetails from "./components/views/sales/GatepassDetails.vue";
import DraftOrders from "./components/views/sales/DraftOrders.vue";
import Orders from "./components/views/sales/Orders.vue";
import OrderItems from "./components/views/sales/OrderItems.vue";
import Receipts from "./components/views/sales/Receipts.vue";
import CreditRequests from "./components/views/credit_limits/CreditRequests.vue";
import CreditReport from "./components/views/credit_limits/CreditReport.vue";
import BuybackReport from "./components/views/buybacks/BuybackReport.vue";
import BuybackDetails from "./components/views/buybacks/BuybackDetails.vue";
import Invoices from "./components/views/sales/Invoices";
import DeliveriesReport from "./components/views/delivery/DeliveriesReport.vue";
import DeliveriesList from "./components/views/delivery/DeliveriesList.vue";
import DeliveryDetails from "./components/views/delivery/DeliveryDetails.vue";
import StockTransferDetails from "./components/views/stock-transfer/StockTransferDetails.vue";
import StockTransferPrint from "./components/views/stock-transfer/StockTransferPrint.vue";
import SalesGatepass from "./components/views/sales/CreateGatepass.vue";
import ServiceGatepass from "./components/views/servicing/ServiceGatepass.vue";
import AddJobCustomer from "./components/views/servicing/AddJobCustomer.vue";

//Servicing
import ManageJobs from "./components/views/servicing/ManageJobs.vue";
import JobsReport from "./components/views/servicing/JobReport.vue";
import JobProfile from "./components/views/servicing/JobProfile.vue";

//delivery
import DeliveryPartnerProfile from "./components/views/delivery/DeliveryPartnerProfile.vue";
import VehicleProfile from "./components/views/delivery/VehicleProfile.vue";
import DriverProfile from "./components/views/delivery/DriverProfile.vue";
import InvoicePrint from "./components/views/sales/InvoicePrint.vue";
import SaleOrderPrint from "./components/views/sales/SaleOrderPrint.vue";
import JobSheetBrief from "./components/views/servicing/JobSheetBrief.vue";
import JobOutwardSummary from "./components/views/servicing/JobOutwardSummary.vue";
import JobInvoice from "./components/views/servicing/JobInvoice.vue";
import CreateReceipt from "./components/views/sales/CreateReceipt.vue";
import ReceiptPrint from "./components/views/sales/ReceiptPrint.vue";
import JobForm from "./components/views/servicing/JobForm.vue";
import ViewOrder from "./components/views/sales/ViewOrder.vue";
import CreateInstantOrder from "./components/views/sales/CreateInstantOrder.vue";
import IMEIHistory from "./components/views/stock-lookup/IMEIHistory.vue";
import PriceCheck from "./components/views/stock-lookup/PriceCheck.vue";
import CollectionReport from "./components/views/sales/CollectionReport.vue";
import AddFormalExpense from "./components/views/expensing/AddFormalExpense.vue";
import AddInformalExpense from "./components/views/expensing/AddInformalExpense.vue";
import CreateExpenseRequest from "./components/views/expensing/CreateExpenseRequest.vue";
import CreateDeliveryTrip from "./components/views/delivery/CreateDeliveryTrip.vue";
import DeliveryTripsList from "./components/views/delivery/DeliveryTripsList.vue";
import DeliveryTripDetails from "./components/views/delivery/DeliveryTripDetails.vue";
import AddDeliveryCommitment from "./components/views/delivery/AddDeliveryCommitment.vue";
import DeliveryCommitmentsList from "./components/views/delivery/DeliveryCommitmentsList.vue";
import ConfirmedTodayDeliveryCommitments from "./components/views/delivery/ConfirmedTodayDeliveryCommitments.vue";
import PreferredTodayDeliveryCommitments from "./components/views/delivery/PreferredTodayDeliveryCommitments.vue";
import DeliveryCommitmentDetails from "./components/views/delivery/DeliveryCommitmentDetails.vue";
import EmployeeProfile from "./components/views/hr/EmployeeProfile.vue";
import MasterVendorsList from "./components/views/masters/ERPVendorsList.vue";

//purchasing
import CreatePurchaseRequest from "./components/views/purchasing/CreatePurchaseRequest.vue";
import CreateGRPO from "./components/views/purchasing/CreateGRPO.vue";
import ViewPurchaseRequest from "./components/views/purchasing/ViewPurchaseRequest.vue";
import PurchaseRequests from "./components/views/purchasing/PurchaseRequests.vue";
import PurchaseOrders from "./components/views/purchasing/PurchaseOrders.vue";
import PurchaseOrderPrint from "./components/views/purchasing/PurchaseOrderPrint.vue";
import GRPO from "./components/views/purchasing/GRPO.vue";

//hr
import UserProfile from "./components/views/hr/UserProfile.vue";
import ProfileImageUploads from "./components/views/hr/ProfileImageUploads.vue";
import UploadAttendanceData from "./components/views/hr/UploadAttendanceData.vue";
import UserProfileOptions from "./components/views/masters/MasterUserProfileOptions.vue";

//reports
import DailyZonewiseSales from "./components/views/reports/DailyZonewiseSales.vue";
import DailyBranchwiseSales from "./components/views/reports/DailyBranchwiseSales.vue";
import DailyDivisionwiseBranchSales from "./components/views/reports/DailyDivisionwiseBranchSales.vue";
import DailyCategorywiseBranchSales from "./components/views/reports/DailyCategorywiseBranchSales.vue";
import DailyProductwiseBranchSales from "./components/views/reports/DailyProductwiseBranchSales.vue";
import DailySalespersonwiseSales from "./components/views/reports/DailySalespersonwiseSales.vue";
import PaymentsGeneralReport from "./components/views/reports/PaymentsGeneralReport.vue";
import GatepassStatusReport from "./components/views/reports/GatepassStatusReport.vue";
import BranchwiseHourlySalesReport from "./components/views/reports/BranchwiseHourlySalesReport.vue";
import HourlySalesReport from "./components/views/reports/HourlySalesReport.vue";
import DetailedHourlySalesReport from "./components/views/reports/DetailedHourlySalesReport.vue";
import DeliveryStatusReport from "./components/views/reports/DeliveryStatusReport.vue";
import ServiceStatusReport from "./components/views/reports/ServiceStatusReport.vue";
import ServiceCategoryReport from "./components/views/reports/ServiceCategoryReport.vue";
import TurnawayStatusReport from "./components/views/reports/TurnawayStatusReport.vue";
//stock transfers
import RequestStockTransferFromGDToSR from "./components/views/stock-transfer/RequestStockTransferFromGDToSR.vue";
import RequestStockTransferFromGDToGD from "./components/views/stock-transfer/RequestStockTransferFromGDToGD.vue";
import RequestStockTransferFromGDToSH from "./components/views/stock-transfer/RequestStockTransferFromGDToSH.vue";
import RequestStockTransferFromSHToSR from "./components/views/stock-transfer/RequestStockTransferFromSHToSR.vue";
import RequestStockTransferFromSHToGD from "./components/views/stock-transfer/RequestStockTransferFromSHToGD.vue";
import RequestStockTransferFromSHToSH from "./components/views/stock-transfer/RequestStockTransferFromSHToSH.vue";
import RequestPreApprovedStockTransferFromSHToSH from "./components/views/stock-transfer/RequestPreApprovedStockTransferFromSHToSH.vue";
import RequestPreApprovedStockTransferFromSHToGD from "./components/views/stock-transfer/RequestPreApprovedStockTransferFromSHToGD.vue";
import RequestPreApprovedStockTransferFromGDToSH from "./components/views/stock-transfer/RequestPreApprovedStockTransferFromGDToSH.vue";
import RequestPreApprovedStockTransferFromGDToGD from "./components/views/stock-transfer/RequestPreApprovedStockTransferFromGDToGD.vue";
import StockCallbackFromSHToGD from "./components/views/stock-transfer/StockCallbackFromSHToGD.vue";
import BulkStockTransfer from "./components/views/stock-transfer/BulkStockTransfer.vue";
import InwardStockRequests from "./components/views/stock-transfer/InwardStockRequests.vue";
import OutwardStockRequests from "./components/views/stock-transfer/OutwardStockRequests.vue";
import StockTransferReport from "./components/views/stock-transfer/StockTransferReport.vue";

//stock lookup
import GroupStockLookup from "./components/views/stock-lookup/GroupStockLookup.vue";
import OtherBranchStockLookup from "./components/views/stock-lookup/OtherBranchStockLookup.vue";
import HomeStockLookup from "./components/views/stock-lookup/HomeStockLookup.vue";
import HomeStockList from "./components/views/stock-lookup/HomeStockList.vue";

//discounting
import DiscountRequests from "./components/views/discounting/ManageDiscountRequests.vue";
import PendingDiscountRequests from "./components/views/discounting/PendingDiscountRequests.vue";

//Intercompany
import InterCompanyInvoices from "./components/views/inter-company/Invoices";
import InterCompanyPurchaseOrders from "./components/views/inter-company/PurchaseOrders.vue";
import InterCompanyGRPO from "./components/views/inter-company/GRPO.vue";
import CreateInterCompanyOrder from "./components/views/inter-company/CreateInterCompanyOrder.vue";

//ERP Reports
import ERPSyncHistory from "./components/views/erp-reports/ERPSyncHistory.vue";
import ERPStockReportsList from "./components/views/erp-reports/ERPStockReportsList.vue";
import ERPSalesReportsList from "./components/views/erp-reports/ERPSalesReportsList.vue";
import ERPStockReport from "./components/views/erp-reports/ERPStockReport.vue";
import ERPSalesReport from "./components/views/erp-reports/ERPSalesReport.vue";

//gifts
import CreateGiftCampaign from "./components/views/marketing/CreateGiftCampaign.vue";
import GiftCampaigns from "./components/views/marketing/GiftCampaigns.vue";
import GiftCampaignDetails from "./components/views/marketing/GiftCampaignDetails.vue";
import GiftRules from "./components/views/marketing/GiftRules.vue";
import GiftRegistrations from "./components/views/marketing/GiftRegistrations.vue";
import GiftAllotments from "./components/views/marketing/GiftAllotments.vue";
import RegisterForGift from "./components/views/marketing/RegisterForGift.vue";
import GiftCategoriesNSubCategories from "./components/views/marketing/GiftCategoriesNSubCategories.vue";
import GiftRedemptions from "./components/views/marketing/GiftRedemptions.vue";

//lead sheet
import LeadSheetImport from "./components/views/marketing/LeadSheetImport.vue";
import Leads from "./components/views/marketing/Leads";

//lead sheet
import IncentiveRules from "./components/views/incentives/IncentiveRules.vue";
import IncentivesLedger from "./components/views/incentives/IncentivesLedger.vue";

//targets
import DailyBranchTargets from "./components/views/targets/DailyBranchTargets.vue";
import DailyUserTargets from "./components/views/targets/DailyUserTargets.vue";
import DailyUserTargetAchievements from "./components/views/targets/DailyUserTargetAchievements.vue";
import TargetAchievementSummary from "./components/views/targets/TargetAchievementSummary.vue";
import MonthlyBranchTargets from "./components/views/targets/MonthlyBranchTargets.vue";
import MonthlyUserTargets from "./components/views/targets/MonthlyUserTargets.vue";
import HourlyBranchTargets from "./components/views/targets/HourlyBranchTargets.vue";
import HourlyUserTargets from "./components/views/targets/HourlyUserTargets.vue";

//Visitor Log
import CreateVisitorLog from "./components/views/office-management/CreateVisitorLog.vue";
import VisitorLogs from "./components/views/office-management/VisitorLogs.vue";
import VisitorLog from "./components/views/office-management/VisitorLog.vue";

//expenses
import ExpenseReport from "./components/views/expensing/ExpenseReport.vue";
import ExpenseDetails from "./components/views/expensing/ExpenseDetails.vue";
import CreateCouponCampaign from "./components/views/marketing/CreateCouponCampaign.vue";
import CouponCampaigns from "./components/views/marketing/CouponCampaigns.vue";
import CouponCampaignDetails from "./components/views/marketing/CouponCampaignDetails.vue";
import PriceLocks from "./components/views/masters/Locks.vue";
import SupportTickets from "./components/views/system/SupportTickets.vue";
import SupportCenter from "./components/views/system/SupportCenter.vue";
import Settings from "./components/views/system/Settings.vue";
import MasterUserProfileOptions from "./components/views/masters/MasterUserProfileOptions.vue";

// Example Routes
// import ExampleComponent from './components/ExampleComponent.vue'

// Role Home
Vue.component(
    "greyman-dash",
    require("./components/views/user-home/Greyman.vue").default
);
Vue.component(
    "sys-admin-dash",
    require("./components/views/user-home/SysAdmin.vue").default
);
Vue.component(
    "mis-admin-dash",
    require("./components/views/user-home/MISAdmin.vue").default
);
Vue.component(
    "secondary-mis-admin-dash",
    require("./components/views/user-home/SecondaryMISAdmin.vue").default
);
Vue.component(
    "service-admin-dash",
    require("./components/views/user-home/ServiceAdmin.vue").default
);
Vue.component(
    "service-manager-dash",
    require("./components/views/user-home/ServiceManager.vue").default
);
Vue.component(
    "service-tech-dash",
    require("./components/views/user-home/ServiceTech.vue").default
);
Vue.component(
    "service-agent-dash",
    require("./components/views/service-agent/Home.vue").default
);
Vue.component(
    "cc-agent-dash",
    require("./components/views/user-home/CCAgent.vue").default
);
Vue.component(
    "cc-manager-dash",
    require("./components/views/user-home/CCManager.vue").default
);
Vue.component(
    "purchase-admin-dash",
    require("./components/views/user-home/PurchaseAdmin.vue").default
);
Vue.component(
    "purchase-manager-dash",
    require("./components/views/user-home/PurchaseManager.vue").default
);
Vue.component(
    "replacement-manager-dash",
    require("./components/views/replacement-manager/Home.vue").default
);
Vue.component(
    "doa-manager-dash",
    require("./components/views/doa-manager/Home.vue").default
);
Vue.component(
    "auditor-dash",
    require("./components/views/user-home/Auditor.vue").default
);
Vue.component(
    "expense-admin-dash",
    require("./components/views/user-home/ExpenseAdmin.vue").default
);
Vue.component(
    "zonal-manager-dash",
    require("./components/views/user-home/ZonalManager.vue").default
);
Vue.component(
    "branch-manager-dash",
    require("./components/views/user-home/BranchManager.vue").default
);
Vue.component(
    "branch-accountant-dash",
    require("./components/views/user-home/BranchAccountant.vue").default
);
Vue.component(
    "warehouse-manager-dash",
    require("./components/views/user-home/WarehouseManager.vue").default
);
Vue.component(
    "installation-admin-dash",
    require("./components/views/user-home/InstallationAdmin.vue").default
);
Vue.component(
    "installation-agent-dash",
    require("./components/views/user-home/InstallationAgent.vue").default
);
Vue.component(
    "user-dash",
    require("./components/views/user-home/User.vue").default
);

// Passport
Vue.component(
    "passport-clients",
    require("./components/passport/Clients.vue").default
);
Vue.component(
    "passport-authorized-clients",
    require("./components/passport/AuthorizedClients.vue").default
);
Vue.component(
    "passport-personal-access-tokens",
    require("./components/passport/PersonalAccessTokens.vue").default
);

const routes = [
    {
        path: "/home",
        component: Home,
    },
    {
        path: "/page",
        meta: { title: "Page Name | Section Name" },
        component: ExampleComponent,
        name: "Page Name | Section Name",
    },
    //notifications
    {
        path: "/notifications",
        meta: { title: "Message Board | Greydesk::O2Suite" },
        component: Notifications,
        name: "Message Board | Greydesk::O2Suite",
    },
    {
        path: "/notification-manager",
        meta: { title: "Notification Manager | Greydesk::O2Suite" },
        component: NotificationManager,
        name: "Notification Manager | Greydesk::O2Suite",
    },
    {
        path: "/create-notification",
        meta: { title: "Create Notifications | Greydesk::O2Suite" },
        component: CreateNotifications,
        name: "Create Notifications | Greydesk::O2Suite",
    },
    // SysAdmin Routes
    {
        path: "/sys-admin/manage-master-companies",
        meta: { title: "Branches | Master" },
        component: SysAdminManageMasterCompanies,
        name: "Branches | Master",
    },
    {
        path: "/sys-admin/manage-master-branches",
        meta: { title: "Branches | Master" },
        component: SysAdminManageMasterBranches,
        name: "Branches | Master",
    },
    {
        path: "/sys-admin/manage-master-employees",
        meta: { title: "Branches | Master" },
        component: SysAdminManageMasterEmployees,
        name: "Branches | Master",
    },
    {
        path: "/sys-admin/manage-master-vendors",
        meta: { title: "Vendors | Master" },
        component: MasterVendorsList,
        name: "Vendors | Master",
    },
    {
        path: "/sys-admin/manage-master-finance-modes",
        meta: { title: "Finance Modes | Master" },
        component: SysAdminManageMasterFinanceModes,
        name: "Finance Modes | Master",
    },
    {
        path: "/sys-admin/manage-master-payment-modes",
        meta: { title: "Payment Modes | Master" },
        component: SysAdminManageMasterPaymentModes,
        name: "Payment Modes | Master",
    },
    {
        path: "/sys-admin/manage-master-tax-codes",
        meta: { title: "Tax Codes | Master" },
        component: SysAdminManageMasterTaxCodes,
        name: "Tax Codes | Master",
    },
    {
        path: "/sys-admin/manage-master-zones",
        meta: { title: "Zones | Master" },
        component: SysAdminManageMasterZones,
        name: "Zones | Master",
    },
    {
        path: "/sys-admin/manage-master-warehouses",
        meta: { title: "Warehouses | Master" },
        component: SysAdminManageMasterWarehouses,
        name: "Warehouses | Master",
    },
    {
        path: "/sys-admin/manage-branch-accounts",
        meta: { title: "Branch Accounts | Master" },
        component: BranchAccounts,
        name: "Branch Accounts | Master",
    },
    {
        path: "/sys-admin/manage-ledger-accounts",
        meta: { title: "Ledger Accounts | Master" },
        component: SysAdminManageLedgerAccounts,
        name: "Ledger Accounts | Master",
    },
    {
        path: "/sys-admin/manage-branches",
        meta: { title: "Branches | Master" },
        component: SysAdminManageBranches,
        name: "Branches | Master",
    },
    {
        path: "/sys-admin/manage-store-stock",
        meta: { title: "Store Stock | Master" },
        component: SysAdminManageStoreStock,
        name: "Store Stock | Master",
    },
    {
        path: "/sys-admin/manage-salesmen",
        meta: { title: "Salesmen | Master" },
        component: SysAdminManageSalesmen,
        name: "Salesmen | Master",
    },
    {
        path: "/sys-admin/manage-users",
        meta: { title: "Users | Master" },
        component: SysAdminManageUsers,
        name: "Users | Master",
    },
    {
        path: "/sys-admin/manage-customers",
        meta: { title: "Customers | Master" },
        component: SysAdminManageCustomers,
        name: "Customers | Master",
    },
    {
        path: "/sys-admin/customer-profile/:id",
        meta: { title: "Customer Profile | Master" },
        component: SysAdminCustomerProfile,
        name: "Customer Profile | Master",
    },
    {
        path: "/sys-admin/manage-category-lists",
        meta: { title: "Category Lists | Master" },
        component: SysAdminManageCategoryLists,
        name: "Category Lists | Master",
    },
    {
        path: "/sys-admin/manage-product-lists",
        meta: { title: "Product Lists | Master" },
        component: SysAdminManageProductLists,
        name: "Product Lists | Master",
    },
    {
        path: "/sys-admin/manage-brands",
        meta: { title: "Brands Lists | Master" },
        component: SysAdminManageBrandsLists,
        name: "Brands Lists | Master",
    },
    {
        path: "/sys-admin/manage-division-lists",
        meta: { title: "Division Lists | Master" },
        component: SysAdminManageDivisionLists,
        name: "Division Lists | Master",
    },
    {
        path: "/sys-admin/manage-division-category-links",
        meta: { title: "Division Category Links | Master" },
        component: SysAdminManageDivisionCategoryLinks,
        name: "Division Category Links | Master",
    },
    {
        path: "/sys-admin/manage-category-product-links",
        meta: { title: "Category Product Links | Master" },
        component: SysAdminManageCategoryProductLinks,
        name: "Category Product Links | Master",
    },
    {
        path: "/manage-bank-offers",
        meta: { title: "Bank Offers | O2POS" },
        component: BankOffers,
        name: "Bank Offers | O2POS",
    },
    {
        path: "/manage-special-offers",
        meta: { title: "Special Offers | O2POS" },
        component: SpecialOffers,
        name: "Special Offers | O2POS",
    },
    {
        path: "/sys-admin/manage-status-lists",
        meta: { title: "Status Lists | Master" },
        component: SysAdminManageStatusLists,
        name: "Status Lists | Master",
    },
    {
        path: "/sys-admin/manage-buyback-rules",
        meta: { title: "Buyback Rules | Master" },
        component: SysAdminManageBuybackRules,
        name: "Buyback Rules | Master",
    },
    {
        path: "/sys-admin/manage-add-on-services",
        meta: { title: "Add On Services | Master" },
        component: SysAdminManageAddOnServices,
        name: "Add On Services | Master",
    },
    {
        path: "/sys-admin/manage-discount-requests",
        meta: { title: "Manage Discount Requests | Master" },
        component: DiscountRequests,
        name: "Manage Discount Requests | Master",
    },
    {
        path: "/sys-admin/manage-campaign-config",
        meta: { title: "Campaign Config | Master" },
        component: SysAdminManageCampaignConfig,
        name: "Campaign Config | Master",
    },
    {
        path: "/sys-admin/manage-delivery-partners",
        meta: { title: "Delivery Partners | Master" },
        component: SysAdminManageDeliveryPartners,
        name: "Delivery Partners | Master",
    },
    {
        path: "/delivery-partner-profile",
        meta: { title: "Delivery Partner Profile | Master" },
        component: DeliveryPartnerProfile,
        name: "Delivery Partner Profile | Master",
    },
    {
        path: "/sys-admin/manage-drivers",
        meta: { title: "Drivers | Master" },
        component: SysAdminManageDrivers,
        name: "Drivers | Master",
    },
    {
        path: "/driver-profile",
        meta: { title: "Driver Profile | Master" },
        component: DriverProfile,
        name: "Driver Profile | Master",
    },
    {
        path: "/sys-admin/manage-vehicles",
        meta: { title: "Vehicles | Master" },
        component: SysAdminManageVehicles,
        name: "Vehicles | Master",
    },
    {
        path: "/vehicle-profile",
        meta: { title: "Vehicle Profile | Master" },
        component: VehicleProfile,
        name: "Vehicle Profile | Master",
    },
    {
        path: "/sys-admin/warehouse-linkages",
        meta: { title: "Warehouse Linkages | Master" },
        component: SysAdminWarehouseLinkages,
        name: "Warehouse Linkages | Master",
    },
    {
        path: "/sys-admin/manage-master-delivery-routes",
        meta: { title: "Master Delivery Routes | Master" },
        component: SysAdminManageMasterDeliveryRoutes,
        name: "Master Delivery Routes | Master",
    },
    {
        path: "/sys-admin/manage-master-delivery-item-config",
        meta: { title: "Master Delivery Item Configuration | Master" },
        component: SysAdminManageMasterDeliveryItemConfig,
        name: "Master Delivery Item Config | Master",
    },
    {
        path: "/sys-admin/manage-modes",
        meta: { title: "Modes | Master" },
        component: SysAdminManageModes,
        name: "Modes | Master",
    },
    {
        path: "/sys-admin/app-passport",
        meta: { title: "App Passport | Master" },
        component: SysAdminAppPassport,
        name: "App Passport | Master",
    },
    {
        path: "/manage-sales-terms",
        meta: { title: "SALES Terms | System Admin" },
        component: TermsOfSales,
        name: "SALES Terms | System Admin",
    },
    {
        path: "/manage-service-terms",
        meta: { title: "SERVICE Terms| System Admin" },
        component: TermsOfService,
        name: "SERVICE Terms | System Admin",
    },
    {
        path: "/manage-purchase-terms",
        meta: { title: "PURCHASE Terms | System Admin" },
        component: TermsOfPurchase,
        name: "PURCHASE Terms | System Admin",
    },
    {
        path: "/service-admin/walkin-report",
        meta: { title: "Walk-in Report | Service Admin" },
        component: ServiceAdminWalkinReport,
        name: "Walk-in Report | Service Admin",
    },
    {
        path: "/sys-admin/service/service-call-origins",
        meta: { title: "Service Call Origins | System Admin" },
        component: SysAdminManageMasterServiceCallOrigins,
        name: "Service Call Origins | System Admin",
    },
    {
        path: "/sys-admin/service/service-call-types",
        meta: { title: "Service Call Types | System Admin" },
        component: SysAdminManageMasterServiceCallTypes,
        name: "Service Call Types | System Admin",
    },
    {
        path: "/sys-admin/service/service-problem-types",
        meta: { title: "Service Problem Types | System Admin" },
        component: SysAdminManageMasterServiceProblemTypes,
        name: "Service Problem Types | System Admin",
    },
    {
        path: "/sys-admin/service/service-problem-sub-types",
        meta: { title: "Service Problem Sub Types | System Admin" },
        component: SysAdminManageMasterServiceProblemSubTypes,
        name: "Service Problem Sub Types | System Admin",
    },
    {
        path: "/sys-admin/support-tickets",
        meta: { title: "Support Tickets | System Admin" },
        component: SupportCenter,
        name: "Support Tickets | System Admin",
    },
    {
        path: "/sys-admin/settings",
        meta: { title: "Settings | System Admin" },
        component: AdminSettings,
        name: "Settings | System Admin",
    },
    {
        path: "/master-user-profile-options",
        meta: { title: "Master User Profile Options | O2HR" },
        component: MasterUserProfileOptions,
        name: "Master User Profile Options | O2HR",
    },
    // Service Agent
    {
        path: "/service-agent/add-job",
        meta: { title: "Add Job | Service Agent" },
        component: ServiceAgentAddJob,
        name: "Add Job | Service Agent",
    },
    {
        path: "/service/add-job-customer/:id",
        meta: { title: "Add Job (Customer Data) | O2Care" },
        component: AddJobCustomer,
        name: "Add Job(Customer Data) | O2Care",
    },
    {
        path: "/service/manage-jobs",
        meta: { title: "Manage Jobs | O2Care" },
        component: ManageJobs,
        name: "Manage Jobs | O2Care",
    },
    {
        path: "/service/job-report",
        meta: { title: "Jobs Report | O2Care" },
        component: JobsReport,
        name: "Jobs Report | O2Care",
    },
    {
        path: "/service/job-profile/:id",
        meta: { title: "Service Job Profile | O2Care" },
        component: JobProfile,
        name: "Service Job Profile | O2Care",
    },
    {
        path: "/service-agent/track-job",
        meta: { title: "Track Job | Service Agent" },
        component: ServiceAgentTrackJobStatus,
        name: "Track Job | Service Agent",
    },
    {
        path: "/service-agent/add-walkin",
        meta: { title: "Add Walk-in | Service Agent" },
        component: ServiceAgentAddWalkin,
        name: "Add Walk-in | Service Agent",
    },
    {
        path: "/service-agent/walkin-report",
        meta: { title: "Walk-in Report | Service Agent" },
        component: ServiceAgentWalkinReport,
        name: "Walk-in Report | Service Agent",
    },
    // {
    //   path: '/service-agent/add-customer',
    //   meta:{ title: 'Add Customer | Service Agent'},
    //   component: ServiceAgentAddCustomer,
    //   name: 'Add Customer | Service Agent'
    // },
    {
        path: "/service-agent/support-tickets",
        meta: { title: "Support Tickets | Service Agent" },
        component: SupportTickets,
        name: "Support Tickets | Service Agent",
    },
    {
        path: "/service-agent/settings",
        meta: { title: "Settings | Service Agent" },
        component: Settings,
        name: "Settings | Service Agent",
    },
    // Service Tech
    {
        path: "/service-tech/job-status-updates",
        meta: { title: "Update Queue | Service Tech" },
        component: ServiceTechJobStatusUpdates,
        name: "Update Queue | Service Tech",
    },
    {
        path: "/service-tech/job-status",
        meta: { title: "Job Status | Service Tech" },
        component: ServiceTechJobStatus,
        name: "Job Status | Service Tech",
    },
    {
        path: "/service-tech/my-performance-report",
        meta: { title: "My Performance Report | Service Tech" },
        component: ServiceTechMyPerformance,
        name: "My Performance Report | Service Tech",
    },
    {
        path: "/service-tech/part-requests",
        meta: { title: "Part Requests | Service Tech" },
        component: ServiceTechPartRequests,
        name: "Part Requests | Service Tech",
    },
    {
        path: "/service-tech/support-tickets",
        meta: { title: "Support Tickets | Service Tech" },
        component: SupportTickets,
        name: "Support Tickets | Service Tech",
    },
    {
        path: "/service-tech/settings",
        meta: { title: "Settings | Service Tech" },
        component: Settings,
        name: "Settings | Service Tech",
    },
    // Service Manager
    {
        path: "/service-manager/add-job",
        meta: { title: "Add Job | Service Manager" },
        component: ServiceManagerAddJob,
        name: "Add Job | Service Manager",
    },
    {
        path: "/service-manager/add-job-customer/:id",
        meta: { title: "Add Job (Customer Data) | Service Manager" },
        component: AddJobCustomer,
        name: "Add Job(Customer Data) | Service Manager",
    },
    {
        path: "/service-manager/job-status",
        meta: { title: "Job Status | Service Manager" },
        component: ServiceManagerJobStatus,
        name: "Job Status | Service Manager",
    },
    {
        path: "/service-manager/add-expense",
        meta: { title: "Add Expense | Service Manager" },
        component: ServiceManagerAddExpense,
        name: "Add Expense | Service Manager",
    },
    {
        path: "/service-manager/gross-profit",
        meta: { title: "Gross Profit | Service Manager" },
        component: ServiceManagerGrossProfit,
        name: "Gross Profit | Service Manager",
    },
    {
        path: "/service-manager/add-item",
        meta: {
            title: "Manage Service Center Inventory - ADD ITEM | Service Manager",
        },
        component: ServiceManagerAddItem,
        name: "Manage Service Center Inventory - ADD ITEM, | Service Manager",
    },
    {
        path: "/service-manager/item-data/:id",
        meta: { title: "Item Info | Service Manager" },
        component: ServiceManagerItemData,
        name: "Item Info | Service Manager",
    },
    {
        path: "/service-manager/manage-inventory",
        meta: { title: "Manage Service Center Inventory | Service Manager" },
        component: ServiceManagerManageInventory,
        name: "Manage Service Center Inventory | Service Manager",
    },
    {
        path: "/service-manager/manage-employees",
        meta: { title: "Manage Employees | Service Manager" },
        component: ServiceManagerManageEmployees,
        name: "Manage Employees | Service Manager",
    },
    {
        path: "/service-manager/manage-employee-review",
        meta: { title: "Manage Employee Review | Service Manager" },
        component: ServiceManagerManageEmployeeReview,
        name: "Manage Employee Review | Service Manager",
    },
    {
        path: "/service-manager/employee-profile/:id",
        meta: { title: "Employee Profile | Service Manager" },
        component: ServiceManagerEmployeeProfile,
        name: "Employee Profile | Service Manager",
    },
    {
        path: "/service-manager/agent-performance-report",
        meta: { title: "Agent Performance Report | Service Manager" },
        component: ServiceManagerAgentPerformanceReport,
        name: "Agent Performance Report | Service Manager",
    },
    {
        path: "/service-manager/collected-amounts",
        meta: { title: "Collected Amounts | Service Manager" },
        component: ServiceManagerCollectedAmounts,
        name: "Collected Amounts | Service Manager",
    },
    {
        path: "/service-manager/net-profit",
        meta: { title: "Net Profit | Service Manager" },
        component: ServiceManagerNetProfit,
        name: "NetProfit | Service Manager",
    },
    {
        path: "/service-manager/add-walkin",
        meta: { title: "Add Walk-in | Service Manager" },
        component: ServiceManagerAddWalkin,
        name: "Add Walk-in | Service Manager",
    },
    {
        path: "/service-manager/walkin-report",
        meta: { title: "Walk-in Report | Service Manager" },
        component: ServiceManagerWalkinReport,
        name: "Walk-in Report | Service Manager",
    },
    {
        path: "/service-manager/support-tickets",
        meta: { title: "Support Tickets | Service Manager" },
        component: SupportTickets,
        name: "Support Tickets | Service Manager",
    },
    {
        path: "/service-manager/settings",
        meta: { title: "Settings | Service Manager" },
        component: Settings,
        name: "Settings | Service Manager",
    },

    //Expense Admin
    {
        path: "/expense-admin/add-formal-expense/:expense_request_id?",
        meta: { title: "Add Formal Expense | Expense Admin" },
        component: AddFormalExpense,
        name: "Add Formal Expense | Expense Admin",
    },
    {
        path: "/expense-admin/add-informal-expense/:expense_request_id?",
        meta: { title: "Add Informal Expense | Expense Admin" },
        component: AddInformalExpense,
        name: "Add Informal Expense | Expense Admin",
    },
    {
        path: "/expense-admin/all-expense-requests",
        meta: { title: "Expense Requests Report | POS" },
        component: ExpenseRequestsReport,
        name: "Expense Requests Report | POS",
    },
    {
        path: "/expense-admin/pending-expense-requests",
        meta: { title: "Pending Expense Requests | POS" },
        component: PendingExpenseRequests,
        name: "Pending Expense Requests | POS",
    },
    {
        path: "/expenses/expense-report",
        meta: { title: "Expense Report | POS" },
        component: ExpenseReport,
        name: "Expense Report | POS",
    },
    {
        path: "/expenses/expense-details/:e_id",
        meta: { title: "Expense Details| POS" },
        component: ExpenseDetails,
        name: "Expense Details| POS",
    },
    {
        path: "/expense-admin/support-tickets",
        meta: { title: "Support Tickets | Expense Admin" },
        component: SupportTickets,
        name: "Support Tickets | Expense Admin",
    },
    {
        path: "/expense-admin/settings",
        meta: { title: "Settings | Expense Admin" },
        component: Settings,
        name: "Settings | Expense Admin",
    },
    // Zonal Manager

    {
        path: "/zonal-manager/request-petty-cash",
        meta: { title: "Request Petty Cash | Zonal Manager" },
        component: RequestPettyCash,
        name: "Request Petty Cash | Zonal Manager",
    },
    {
        path: "/zonal-manager/create-expense-request",
        meta: { title: "Create Expense Request | Zonal Manager" },
        component: CreateExpenseRequest,
        name: "Create Expense Request | Zonal Manager",
    },
    {
        path: "/zonal-manager/manage-expenses",
        meta: { title: "Manage Expenses | Zonal Manager" },
        component: ExpenseReport,
        name: "Manage Expenses | Zonal Manager",
    },
    {
        path: "/zonal-manager/stock-transfer-requests",
        meta: { title: "Stock Transfer Requests | Zonal Manager" },
        component: ZonalManagerStockTransferRequests,
        name: "Stock Transfer Requests | Zonal Manager",
    },
    {
        path: "/zonal-manager/discount-requests",
        meta: { title: "Discount Requests | Zonal Manager" },
        component: DiscountRequests,
        name: "Discount Requests | Zonal Manager",
    },
    {
        path: "/zonal-manager/manage-receipts",
        meta: { title: "Manage Receipts | Zonal Manager" },
        component: Receipts,
        name: "Manage Receipts | Zonal Manager",
    },
    {
        path: "/zonal-manager/settings",
        meta: { title: "Settings | Zonal Manager" },
        component: Settings,
        name: "Settings | Zonal Manager",
    },
    // Branch Manager
    {
        path: "/deliveries-report",
        meta: { title: "Deliveries Report | DELIVERY" },
        component: DeliveriesReport,
        name: "Deliveries Report | DELIVERY",
    },
    {
        path: "/deliveries-list",
        meta: { title: "Manage Deliveries | DELIVERY" },
        component: DeliveriesList,
        name: "Manage Deliveries | DELIVERY",
    },
    {
        path: "/delivery-details/:gatepass/:order",
        meta: { title: "Delivery Details | DELIVERY" },
        component: DeliveryDetails,
        name: "Delivery Details | DELIVERY",
    },
    {
        path: "/create-delivery-trip",
        meta: { title: "Create Delivery Trip | DELIVERY" },
        component: CreateDeliveryTrip,
        name: "Create Delivery Trip | DELIVERY",
    },
    {
        path: "/delivery-trips-list",
        meta: { title: "Delivery Trips | DELIVERY" },
        component: DeliveryTripsList,
        name: "Delivery Trips | DELIVERY",
    },
    {
        path: "/delivery-trip/:id",
        meta: { title: "Manage Delivery Trip | DELIVERY" },
        component: DeliveryTripDetails,
        name: "Manage Delivery Trip | DELIVERY",
    },
    {
        path: "/branch-manager/manage-branch-accounts",
        meta: { title: "Branch Accounts | Branch Manager" },
        component: BranchAccounts,
        name: "Branch Accounts | Branch Manager",
    },
    {
        path: "/branch-manager/add-expense",
        meta: { title: "Create Expense Request | Branch Manager" },
        component: CreateExpenseRequest,
        name: "Craete Expense Request | Branch Manager",
    },
    {
        path: "/branch-manager/manage-expenses",
        meta: { title: "Manage Expenses | Branch Manager" },
        component: ExpenseReport,
        name: "Manage Expenses | Branch Manager",
    },
    {
        path: "/branch-manager/inward-stock-requests",
        meta: {
            title: "To Give Stock - Requests from Others | Branch Manager",
        },
        component: InwardStockRequests,
        name: "To Give Stock - Requests from Others | Branch Manager",
    },
    {
        path: "/branch-manager/outward-stock-requests",
        meta: { title: "To Get Stock - Requests from Here | Branch Manager" },
        component: OutwardStockRequests,
        name: "To Get Stock - Requests from Here | Branch Manager",
    },
    {
        path: "/branch-manager/discount-requests",
        meta: { title: "Discount Requests | Branch Manager" },
        component: DiscountRequests,
        name: "Discount Requests | Branch Manager",
    },

    // Warehouse Manager

    {
        path: "/request-petty-cash",
        meta: { title: "Request Petty Cash | O2POS" },
        component: RequestPettyCash,
        name: "Request Petty Cash | O2POS",
    },
    {
        path: "/warehouse-manager/job-status-updates",
        meta: { title: "Update Queue | Warehouse Manager" },
        component: ServiceTechJobStatusUpdates,
        name: "Update Queue | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/job-status",
        meta: { title: "Job Status | Warehouse Manager" },
        component: ServiceTechJobStatus,
        name: "Job Status | Warehouse Manager",
    },
    {
        path: "/deliveries-report",
        meta: { title: "Deliveries Report | DELIVERY" },
        component: DeliveriesReport,
        name: "Deliveries Report | DELIVERY",
    },
    {
        path: "/deliveries-list",
        meta: { title: "Manage Deliveries | DELIVERY" },
        component: DeliveriesList,
        name: "Manage Deliveries | DELIVERY",
    },
    {
        path: "/delivery-details/:gatepass/:order",
        meta: { title: "Delivery Details | DELIVERY" },
        component: DeliveryDetails,
        name: "Delivery Details | DELIVERY",
    },
    {
        path: "/create-delivery-trip",
        meta: { title: "Create Delivery Trip | DELIVERY" },
        component: CreateDeliveryTrip,
        name: "Create Delivery Trip | DELIVERY",
    },
    {
        path: "/delivery-trips-list",
        meta: { title: "Delivery Trips | DELIVERY" },
        component: DeliveryTripsList,
        name: "Delivery Trips | DELIVERY",
    },
    {
        path: "/delivery-trip/:id",
        meta: { title: "Manage Delivery Trip | DELIVERY" },
        component: DeliveryTripDetails,
        name: "Manage Delivery Trip | DELIVERY",
    },
    {
        path: "/manage-branch-accounts",
        meta: { title: "Branch Accounts | Warehouse Manager" },
        component: BranchAccounts,
        name: "Branch Accounts | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/add-expense",
        meta: { title: "Create Expense Request | Warehouse Manager" },
        component: CreateExpenseRequest,
        name: "Craete Expense Request | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/manage-expenses",
        meta: { title: "Manage Expenses | Warehouse Manager" },
        component: ExpenseReport,
        name: "Manage Expenses | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/inward-stock-requests",
        meta: {
            title: "To Give Stock - Requests from Others | Warehouse Manager",
        },
        component: InwardStockRequests,
        name: "To Give Stock - Requests from Others | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/outward-stock-requests",
        meta: {
            title: "To Get Stock - Requests from Here | Warehouse Manager",
        },
        component: OutwardStockRequests,
        name: "To Get Stock - Requests from Here | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/discount-requests",
        meta: { title: "Discount Requests | Warehouse Manager" },
        component: DiscountRequests,
        name: "Discount Requests | Warehouse Manager",
    },
    // Replacement Manager
    {
        path: "/replacement-manager/add-job",
        meta: { title: "Add Job | Replacement Manager" },
        component: ReplacementManagerAddJob,
        name: "Add Job | Replacement Manager",
    },
    {
        path: "/replacement-manager/add-job-customer/:id",
        meta: { title: "Add Job (Customer Data) | Replacement Manager" },
        component: AddJobCustomer,
        name: "Add Job(Customer Data) | Replacement Manager",
    },
    {
        path: "/replacement-manager/job-status",
        meta: { title: "Job Status | Replacement Manager" },
        component: ReplacementManagerJobStatus,
        name: "Job Status | Replacement Manager",
    },
    {
        path: "/replacement-manager/manage-inventory",
        meta: {
            title: "Manage Service Center Inventory | Replacement Manager",
        },
        component: ReplacementManagerManageInventory,
        name: "Manage Service Center Inventory | Replacement Manager",
    },
    {
        path: "/replacement-manager/manage-employees",
        meta: { title: "Manage Employees | Replacement Manager" },
        component: ReplacementManagerManageEmployees,
        name: "Manage Employees | Replacement Manager",
    },
    {
        path: "/replacement-manager/employee-profile/:id",
        meta: { title: "Employee Profile | Replacement Manager" },
        component: ReplacementManagerEmployeeProfile,
        name: "Employee Profile | Replacement Manager",
    },
    {
        path: "/replacement-manager/agent-performance-report",
        meta: { title: "Agent Performance Report | Replacement Manager" },
        component: ReplacementManagerAgentPerformanceReport,
        name: "Agent Performance Report | Replacement Manager",
    },
    {
        path: "/replacement-manager/financial-report",
        meta: { title: "Financial Report | Replacement Manager" },
        component: ReplacementManagerFinancialReport,
        name: "Financial Report | Replacement Manager",
    },
    {
        path: "/replacement-manager/support-tickets",
        meta: { title: "Support Tickets | Replacement Manager" },
        component: SupportTickets,
        name: "Support Tickets | Replacement Manager",
    },
    {
        path: "/replacement-manager/settings",
        meta: { title: "Settings | Replacement Manager" },
        component: Settings,
        name: "Settings | Replacement Manager",
    },
    // DOA Manager
    {
        path: "/doa-manager/add-job",
        meta: { title: "Add Job | DOA Manager" },
        component: DOAManagerAddJob,
        name: "Add Job | DOA Manager",
    },
    {
        path: "/doa-manager/add-job-customer/:id",
        meta: { title: "Add Job (Customer Data) | DOA Manager" },
        component: AddJobCustomer,
        name: "Add Job(Customer Data) | DOA Manager",
    },
    {
        path: "/doa-manager/job-status",
        meta: { title: "Job Status | DOA Manager" },
        component: DOAManagerJobStatus,
        name: "Job Status | DOA Manager",
    },
    {
        path: "/doa-manager/manage-inventory",
        meta: { title: "Manage Service Center Inventory | DOA Manager" },
        component: DOAManagerManageInventory,
        name: "Manage Service Center Inventory | DOA Manager",
    },
    {
        path: "/doa-manager/manage-employees",
        meta: { title: "Manage Employees | DOA Manager" },
        component: DOAManagerManageEmployees,
        name: "Manage Employees | DOA Manager",
    },
    {
        path: "/doa-manager/employee-profile/:id",
        meta: { title: "Employee Profile | DOA Manager" },
        component: DOAManagerEmployeeProfile,
        name: "Employee Profile | DOA Manager",
    },
    {
        path: "/doa-manager/agent-performance-report",
        meta: { title: "Agent Performance Report | DOA Manager" },
        component: DOAManagerAgentPerformanceReport,
        name: "Agent Performance Report | DOA Manager",
    },
    {
        path: "/doa-manager/financial-report",
        meta: { title: "Financial Report | Replacement Manager" },
        component: DOAManagerFinancialReport,
        name: "Financial Report | DOA Manager",
    },
    {
        path: "/doa-manager/support-tickets",
        meta: { title: "Support Tickets | DOA Manager" },
        component: SupportTickets,
        name: "Support Tickets | DOA Manager",
    },
    {
        path: "/doa-manager/settings",
        meta: { title: "Settings | DOA Manager" },
        component: Settings,
        name: "Settings | DOA Manager",
    },
    // Extended Warranty Admin
    {
        path: "/ext-warr-admin/add-job",
        meta: { title: "Add Job | Extended Warranty Admin" },
        component: ExtWarrAdminAddJob,
        name: "Add Job | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/add-job-customer/:id",
        meta: { title: "Add Job (Customer Data) | Extended Warranty Admin" },
        component: AddJobCustomer,
        name: "Add Job(Customer Data) | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/job-status",
        meta: { title: "Job Status | Extended Warranty Admin" },
        component: ExtWarrAdminJobStatus,
        name: "Job Status | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/manage-inventory",
        meta: {
            title: "Manage Service Center Inventory | Extended Warranty Admin",
        },
        component: ExtWarrAdminManageInventory,
        name: "Manage Service Center Inventory | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/manage-employees",
        meta: { title: "Manage Employees | Extended Warranty Admin" },
        component: ExtWarrAdminManageEmployees,
        name: "Manage Employees | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/employee-profile/:id",
        meta: { title: "Employee Profile | Extended Warranty Admin" },
        component: ExtWarrAdminEmployeeProfile,
        name: "Employee Profile | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/agent-performance-report",
        meta: { title: "Agent Performance Report | Extended Warranty Admin" },
        component: ExtWarrAdminAgentPerformanceReport,
        name: "Agent Performance Report | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/financial-report",
        meta: { title: "Financial Report | Extended Warranty Admin" },
        component: ExtWarrAdminFinancialReport,
        name: "Financial Report | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/add-on-slabs",
        meta: { title: "Manage Add-on Services | Extended Warranty Admin" },
        component: SysAdminManageAddOnServices,
        name: "Manage Add-on Services | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/support-tickets",
        meta: { title: "Support Tickets | Extended Warranty Admin" },
        component: SupportTickets,
        name: "Support Tickets | Extended Warranty Admin",
    },
    {
        path: "/ext-warr-admin/settings",
        meta: { title: "Settings | Extended Warranty Admin" },
        component: Settings,
        name: "Settings | Extended Warranty Admin",
    },
    // Service Admin
    {
        path: "/service-admin/job-status",
        meta: { title: "Job Status | Service Admin" },
        component: ServiceAdminJobStatus,
        name: "Job Status | Service Admin",
    },
    {
        path: "/service-admin/manage-employees",
        meta: { title: "Manage Employees | Service Admin" },
        component: ServiceAdminManageEmployees,
        name: "Manage Employees | Service Admin",
    },
    {
        path: "/service-admin/employee-profile/:id",
        meta: { title: "Employee Profile | Service Admin" },
        component: ServiceAdminEmployeeProfile,
        name: "Employee Profile | Service Admin",
    },
    {
        path: "/service-admin/agent-performance-report",
        meta: { title: "Agent Performance Report | Service Admin" },
        component: ServiceAdminAgentPerformanceReport,
        name: "Agent Performance Report | Service Admin",
    },
    {
        path: "/service-admin/manage-employee-review",
        meta: { title: "Manage Employee Review | Service Admin" },
        component: ServiceAdminManageEmployeeReview,
        name: "Manage Employee Review | Service Admin",
    },
    {
        path: "/service-admin/collected-amounts",
        meta: { title: "Collected Amounts | Service Admin" },
        component: ServiceAdminCollectedAmounts,
        name: "Collected Amounts | Service Admin",
    },
    {
        path: "/service-admin/add-expense",
        meta: { title: "Add Expense | Service Admin" },
        component: ServiceAdminAddExpense,
        name: "Add Expense | Service Admin",
    },
    {
        path: "/service-admin/gross-profit",
        meta: { title: "Gross Profit | Service Admin" },
        component: ServiceAdminGrossProfit,
        name: "Gross Profit | Service Admin",
    },
    {
        path: "/service-admin/net-profit",
        meta: { title: "Net Profit | Service Admin" },
        component: ServiceAdminNetProfit,
        name: "Net Profit | Service Admin",
    },
    {
        path: "/service-admin/branchwise-net-profit",
        meta: { title: "Branchwise Net Profit | Service Admin" },
        component: ServiceAdminBranchwiseNetProfitReport,
        name: "Branchwise Net Profit | Service Admin",
    },
    {
        path: "/service-admin/branchwise-gross-profit",
        meta: { title: "Branchwise Gross Profit | Service Admin" },
        component: ServiceAdminBranchwiseGrossProfitReport,
        name: "Branchwise Gross Profit | Service Admin",
    },
    {
        path: "/service-admin/branchwise-daily-financials",
        meta: { title: "Branchwise Daily Financials | Service Admin" },
        component: ServiceAdminBranchwiseDailyFinancialReport,
        name: "Branchwise Daily Financials | Service Admin",
    },
    {
        path: "/service-admin/branchwise-item-category-counts",
        meta: { title: "Branchwise Item Category Counts | Service Admin" },
        component: ServiceAdminBranchwiseItemCategoryCounts,
        name: "Branchwise Item Category Counts | Service Admin",
    },
    {
        path: "/service-admin/branchwise-job-category-counts",
        meta: { title: "Branchwise Job Category Counts | Service Admin" },
        component: ServiceAdminBranchwiseJobCategoryCounts,
        name: "Branchwise Job Category Counts | Service Admin",
    },
    {
        path: "/service-admin/annual-branchwise-net-profit",
        meta: { title: "Annual Branchwise Net Profit | Service Admin" },
        component: ServiceAdminAnnualBranchwiseNetProfitReport,
        name: "Annual Branchwise Net Profit | Service Admin",
    },
    {
        path: "/service-admin/annual-branchwise-gross-profit",
        meta: { title: "Annual Branchwise Gross Profit | Service Admin" },
        component: ServiceAdminAnnualBranchwiseGrossProfitReport,
        name: "Annual Branchwise Gross Profit | Service Admin",
    },
    {
        path: "/service-admin/add-item",
        meta: { title: "Add Item | Service Admin" },
        component: ServiceAdminAddItem,
        name: "Add Item | Service Admin",
    },
    {
        path: "/service-admin/manage-inventory",
        meta: { title: "Manage Inventory | Service Admin" },
        component: ServiceAdminManageInventory,
        name: "Manage Inventory | Service Admin",
    },
    {
        path: "/service-admin/item-data/:id",
        meta: { title: "Item Info | Service Admin" },
        component: ServiceAdminItemData,
        name: "Item Info | Service Admin",
    },
    {
        path: "/service-admin/support-tickets",
        meta: { title: "Support Tickets | Service Admin" },
        component: SupportTickets,
        name: "Support Tickets | Service Admin",
    },
    {
        path: "/service-admin/settings",
        meta: { title: "Settings | Service Admin" },
        component: Settings,
        name: "Settings | Service Admin",
    },
    // Purchase Manager
    {
        path: "/purchase-manager/add-item",
        meta: { title: "Add Item | Purchase Manager" },
        component: PurchaseManagerAddItem,
        name: "Add Item | Purchase Manager",
    },
    {
        path: "/purchase-manager/manage-inventory",
        meta: { title: "Manage Inventory | Purchase Manager" },
        component: PurchaseManagerManageInventory,
        name: "Manage Inventory | Purchase Manager",
    },
    {
        path: "/purchase-manager/item-data/:id",
        meta: { title: "Item Info | Purchase Manager" },
        component: PurchaseManagerItemData,
        name: "Item Info | Purchase Manager",
    },
    {
        path: "/purchase-manager/item-requests",
        meta: { title: "Item Requests | Purchase Manager" },
        component: PurchaseManagerItemRequests,
        name: "Item Requests | Purchase Manager",
    },
    {
        path: "/purchase-manager/purchase-order/:id",
        meta: { title: "Purchase Order | Purchase Manager" },
        component: PurchaseManagerPurchaseOrder,
        name: "Purchase Order | Purchase Manager",
    },
    {
        path: "/purchase-manager/request-data/:id",
        meta: { title: "Request Details | Purchase Manager" },
        component: PurchaseManagerRequestData,
        name: "Request Details | Purchase Manager",
    },

    //Auditor
    {
        path: "/auditor/sales/daily-stats",
        meta: { title: "Daily Stats | Auditor" },
        component: DailyStats,
        name: "Daily Stats | Auditor",
    },
    {
        path: "/auditor/sales/monthly-stats",
        meta: { title: "Monthly Stats | Auditor" },
        component: MonthlyStats,
        name: "Monthly Stats | Auditor",
    },

    // User Routes
    {
        path: "/user/track-job",
        meta: { title: "Track Job | User" },
        component: UserTrackJob,
        name: "Track Job | User",
    },
    {
        path: "/user/job-profile/:id",
        meta: { title: "Job Info | User" },
        component: UserJobProfile,
        name: "Job Info | User",
    },
    {
        path: "/user/job-sheet-brief/:id",
        meta: { title: "Job Sheet - Print | User" },
        component: UserJobSheetBrief,
        name: "Job Sheet - Print | User",
    },
    // sales
    {
        path: "/manage-gatepass",
        meta: { title: "Manage Gatepasses | O2CRM" },
        component: Gatepasses,
        name: "Manage Gatepasses | O2CRM",
    },
    {
        path: "/manage-draft-orders",
        meta: { title: "Manage Draft Orders | O2POS" },
        component: DraftOrders,
        name: "Manage Draft Orders | O2POS",
    },
    {
        path: "/manage-orders",
        meta: { title: "Manage Orders | O2POS" },
        component: Orders,
        name: "Manage Orders | O2POS",
    },
    {
        path: "/order-items",
        meta: { title: "Order Items | O2POS" },
        component: OrderItems,
        name: "OrderItems | O2POS",
    },
    {
        path: "/list-invoices/:branch?/:from?/:to?",
        meta: { title: "List Invoices  | O2POS" },
        component: Invoices,
        name: "List Invoices | O2POS",
    },
    {
        path: "/gatepass/gatepass-details/:id",
        meta: { title: "Gatepass Details | O2CRM" },
        component: GatepassDetails,
        name: "Gatepass Details | O2Suite",
    },
    {
        path: "/create-receipt",
        meta: { title: "Create Receipt | O2POS" },
        component: CreateReceipt,
        name: "Create Receipt | O2POS",
    },
    {
        path: "/manage-receipts",
        meta: { title: "Manage Receipts | O2POS" },
        component: Receipts,
        name: "Manage Receipts | O2POS",
    },
    {
        path: "/sale-order/:order_id/",
        meta: { title: "Sale Order | Oxygen Digital Shop" },
        component: SaleOrderPrint,
        name: "Sale Order | Oxygen Digital Shop",
    },
    {
        path: "/invoice/:invoice_id/:g_id",
        meta: { title: "Invoice - Print | Oxygen Digital Shop" },
        component: InvoicePrint,
        name: "Invoice - Print | Oxygen Digital Shop",
    },
    {
        path: "/receipt/:receipt_id",
        meta: { title: "Receipt - Print | Oxygen Digital Shop" },
        component: ReceiptPrint,
        name: "Receipt - Print | Oxygen Digital Shop",
    },
    {
        path: "/sales/new-gatepass/:lead_id?",
        meta: { title: "New Sales Gatepass | Oxygen Digital Shop" },
        component: SalesGatepass,
        name: "New Sales Gatepass | Oxygen Digital Shop",
    },
    //incentives
    {
        path: "/hourly-user-targets",
        meta: { title: "Hourly User Targets  | O2POS" },
        component: HourlyUserTargets,
        name: "Hourly User Targets  | O2POS",
    },
    {
        path: "/hourly-branch-targets",
        meta: { title: "Hourly Branch Targets  | O2POS" },
        component: HourlyBranchTargets,
        name: "Hourly Branch Targets  | O2POS",
    },
    {
        path: "/daily-user-targets",
        meta: { title: "Daily User Targets  | O2POS" },
        component: DailyUserTargets,
        name: "Daily User Targets  | O2POS",
    },
    {
        path: "/daily-user-target-achievements",
        meta: { title: "Daily User Target Achievements | O2POS" },
        component: DailyUserTargetAchievements,
        name: "Daily User Target Achievements  | O2POS",
    },
    {
        path: "/target-achievement-summary",
        meta: { title: "Target Achievement Summary | O2POS" },
        component: TargetAchievementSummary,
        name: "Target Achievement Summary  | O2POS",
    },
    {
        path: "/daily-branch-targets",
        meta: { title: "Daily Branch Targets  | O2POS" },
        component: DailyBranchTargets,
        name: "Daily Branch Targets  | O2POS",
    },
    {
        path: "/monthly-user-targets",
        meta: { title: "Monthly User Targets  | O2POS" },
        component: MonthlyUserTargets,
        name: "Monthly User Targets  | O2POS",
    },
    {
        path: "/monthly-branch-targets",
        meta: { title: "Monthly Branch Targets  | O2POS" },
        component: MonthlyBranchTargets,
        name: "Monthly Branch Targets  | O2POS",
    },
    //incentives
    {
        path: "/manage-incentive-rules",
        meta: { title: "Manage Spot Incentive Rules  | O2POS" },
        component: IncentiveRules,
        name: "Manage Spot Incentive Rules  | O2POS",
    },
    {
        path: "/manage-incentives-ledger",
        meta: { title: "Manage Incentives Ledger  | O2POS" },
        component: IncentivesLedger,
        name: "Manage Incentives Ledger  | O2POS",
    },
    //marketing
    {
        path: "/lead-import/bulk",
        meta: { title: "Lead Sheet  | Import Wizard" },
        component: LeadSheetImport,
        name: "Lead Sheet | Import Wizard",
    },
    {
        path: "/leads",
        meta: { title: "Lead Sheet  | O2CRM" },
        component: Leads,
        name: "Lead Sheet  | O2CRM",
    },
    {
        path: "/coupon/create-coupon-campaign",
        meta: { title: "Create Coupon Campaign | O2CRM" },
        component: CreateCouponCampaign,
        name: "Create Coupon Campaign | O2CRM",
    },
    {
        path: "/coupon/coupon-campaigns",
        meta: { title: "Coupon Campaigns | O2CRM" },
        component: CouponCampaigns,
        name: "Coupon Campaigns | O2CRM",
    },
    {
        path: "/coupon/coupon-campaign-details/:id",
        meta: { title: "Coupon Campaign Details | O2CRM" },
        component: CouponCampaignDetails,
        name: "Coupon Campaign Details | O2CRM",
    },
    {
        path: "/sys-admin/price-locks",
        meta: { title: "Price Locks | O2Care  - Oxygen Digital Shop" },
        component: PriceLocks,
        name: "Price Locks | O2Care  - Oxygen Digital Shop",
    },
    {
        path: "/imei-history",
        meta: { title: "IMEI History | POS" },
        component: IMEIHistory,
        name: "IMEI History | POS",
    },
    {
        path: "/price-check",
        meta: { title: "Price Checker | POS" },
        component: PriceCheck,
        name: "Price Checker | POS",
    },
    {
        path: "/collection-report",
        meta: { title: "Collection Report | POS" },
        component: CollectionReport,
        name: "Collection Report | POS",
    },
    {
        path: "/create-instant-order/:gatepass?/:draftorder?",
        meta: { title: "Order Management | O2POS" },
        component: CreateInstantOrder,
        name: "Order Management | O2POS",
    },
    {
        path: "/create-inter-company/:gatepass?/:draftorder?",
        meta: { title: "Inter Company Order Management | POS" },
        component: CreateInterCompanyOrder,
        name: "Inter Company Order Management | POS",
    },
    {
        path: "/view-order/:g_id/:do_id/:o_id",
        meta: { title: "Invoicing | POS" },
        component: ViewOrder,
        name: "Invoicing | POS",
    },
    {
        path: "/create-purchase-request/:purchase_request?",
        meta: { title: "Create Purchase Request | POS" },
        component: CreatePurchaseRequest,
        name: "Create PurchaseRequest | POS",
    },
    {
        path: "/create-grpo/:purchase_order?/:grpo?",
        meta: { title: "GRPO | POS" },
        component: CreateGRPO,
        name: "GRPO | POS",
    },
    {
        path: "/view-purchase-request/:pr_id",
        meta: { title: "View Purchase Request | POS" },
        component: ViewPurchaseRequest,
        name: "View Purchase Request | POS",
    },
    {
        path: "/purchase-orders",
        meta: { title: "Purchase Orders | POS" },
        component: PurchaseOrders,
        name: "Purchase Orders | POS",
    },
    {
        path: "/purchase-requests",
        meta: { title: "Purchase Requests | POS" },
        component: PurchaseRequests,
        name: "Purchase Requests | POS",
    },
    {
        path: "/grpo",
        meta: { title: "GRPOs | POS" },
        component: GRPO,
        name: "GRPOs | POS",
    },
    {
        path: "/purchasing/po_print/:po_id/:pr_id",
        meta: { title: "Purchase Order - Print | Oxygen Digital Shop" },
        component: PurchaseOrderPrint,
        name: "Purchase Order - Print | Oxygen Digital Shop",
    },
    {
        path: "/job-sheet-brief/:id",
        meta: { title: "Job Sheet - Print | O2Care  - Oxygen Digital Shop" },
        component: JobSheetBrief,
        name: "Job Sheet - Print | O2Care  - Oxygen Digital Shop",
    },
    {
        path: "/job-outward-summary/:id",
        meta: { title: "Outward Summary | O2Care - Oxygen Digital Shop" },
        component: JobOutwardSummary,
        name: "Outward Summary | O2Care - Oxygen Digital Shop",
    },
    {
        path: "/job-invoice/:inv_id/:job_id/:u_id",
        meta: { title: "Job Invoice - Print | O2Care  - Oxygen Digital Shop" },
        component: JobInvoice,
        name: "Job Sheet - Print | O2Care  - Oxygen Digital Shop",
    },
    {
        path: "/receipt/:r_id",
        meta: { title: "Receipt - Print | O2Care  - Oxygen Digital Shop" },
        component: ReceiptPrint,
        name: "Receipt - Print | O2Care  - Oxygen Digital Shop",
    },
    {
        //pass params in background. Not URL
        path: "/stock-transfer-details/:id",
        meta: { title: "Stock Transfer Details | Oxygen Digital Shop" },
        component: StockTransferDetails,
        name: "Stock Transfer Details | Oxygen Digital Shop",
    },
    {
        path: "/stock-transfer/print/:str-id",
        meta: { title: "Stock Transfer | Oxygen Digital Shop" },
        component: StockTransferPrint,
        name: "Stock Transfer | Oxygen Digital Shop",
    },
    {
        path: "/branch-manager/request-damaged-stock-transfer",
        meta: { title: "Request Stock Transfer - To SR | Branch Manager" },
        component: RequestStockTransferFromSHToSR,
        name: "Request Stock Transfer - To SR | Branch Manager",
    },
    {
        path: "/branch-manager/request-new-stock-transfer",
        meta: { title: "Request Stock Transfer - To GD | Branch Manager" },
        component: RequestStockTransferFromSHToGD,
        name: "Request Stock Transfer - To GD | Branch Manager",
    },
    {
        path: "/branch-manager/request-existing-stock-transfer",
        meta: { title: "Request Stock Transfer - To SH | Branch Manager" },
        component: RequestStockTransferFromSHToSH,
        name: "Request Stock Transfer - To SH | Branch Manager",
    },
    {
        path: "/warehouse-manager/request-damaged-stock-transfer",
        meta: {
            title: "Create Stock Transfer Document - SR | Warehouse Manager",
        },
        component: RequestStockTransferFromGDToSR,
        name: "Create Stock Transfer Document - To SR | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/request-new-stock-transfer",
        meta: {
            title: "Create Stock Transfer Document - To GD | Warehouse Manager",
        },
        component: RequestStockTransferFromGDToGD,
        name: "Create Stock Transfer Document - To GD  | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/request-existing-stock-transfer",
        meta: {
            title: "Create Stock Transfer Document - To SH | Warehouse Manager",
        },
        component: RequestStockTransferFromGDToSH,
        name: "Create Stock Transfer Document - To SH | Warehouse Manager",
    },
    {
        path: "/warehouse-manager/stock-callback-request-from-sh-to-gd",
        meta: { title: "Stock Callback Request - To GD | Warehouse Manager" },
        component: StockCallbackFromSHToGD,
        name: "Stock Callback Request - To GD | Warehouse Manager",
    },
    {
        path: "/mis/request-sh-to-sh-stock-transfer",
        meta: { title: "Request Stock Transfer - SH To SH | Purchasing" },
        component: RequestPreApprovedStockTransferFromSHToSH,
        name: "Request Stock Transfer - SH To SH | Purchasing",
    },
    {
        path: "/mis/request-sh-to-gd-stock-transfer",
        meta: { title: "Request Stock Transfer - SH To GD | Purchasing" },
        component: RequestPreApprovedStockTransferFromSHToGD,
        name: "Request Stock Transfer - SH To GD | Purchasing",
    },
    {
        path: "/mis/request-gd-to-gd-stock-transfer",
        meta: { title: "Request Stock Transfer - GD To GD | Purchasing" },
        component: RequestPreApprovedStockTransferFromGDToGD,
        name: "Request Stock Transfer - SH To SH | Purchasing",
    },
    {
        path: "/mis/request-gd-to-sh-stock-transfer",
        meta: { title: "Request Stock Transfer - GD To SH | Purchasing" },
        component: RequestPreApprovedStockTransferFromGDToSH,
        name: "Request Stock Transfer - GD To SH | Purchasing",
    },
    {
        path: "/service/new-gatepass",
        meta: { title: "New Service Gatepass | Oxygen Digital Shop" },
        component: ServiceGatepass,
        name: "New Service Gatepass | Oxygen Digital Shop",
    },
    {
        path: "/service/new-job/:gatepass",
        meta: { title: "Job Form | Oxygen Digital Shop" },
        component: JobForm,
        name: "Job Form | Oxygen Digital Shop",
    },
    {
        path: "/sales/buyback-report",
        meta: { title: "Buyback Report | Oxygen Digital Shop" },
        component: BuybackReport,
        name: "Buyback Report | Oxygen Digital Shop",
    },
    {
        path: "/sales/buyback-report/details/:id",
        meta: { title: "Buyback Details | Oxygen Digital Shop" },
        component: BuybackDetails,
        name: "Buyback Details | Oxygen Digital Shop",
    },
    {
        path: "/credit/requests",
        meta: { title: "Credit Requests | Oxygen Digital Shop" },
        component: CreditRequests,
        name: "Credit Requests | Oxygen Digital Shop",
    },
    {
        path: "/credit/report",
        meta: { title: "Credit Limit Report | Oxygen Digital Shop" },
        component: CreditReport,
        name: "Credit Limit Report | Oxygen Digital Shop",
    },
    // {
    //   path: '/lead/profile',
    //   meta:{ title: 'Lead Profile | Oxygen Digital Shop'},
    //   component: LeadProfile,
    //   name: 'Lead Profile | Oxygen Digital Shop'
    // },
    {
        path: "/gift/redemptions",
        meta: { title: "Gift Redemptions and Status | O2Suite" },
        component: GiftRedemptions,
        name: "Gift Redemptions and Status | O2Suite",
    },
    {
        path: "/gift/create-campaign",
        meta: { title: "Create Gift Campaign | O2Suite" },
        component: CreateGiftCampaign,
        name: "Create Gift Campaign | O2Suite",
    },
    {
        path: "/gift/view-campaigns",
        meta: { title: "Gift Campaigns | O2Suite" },
        component: GiftCampaigns,
        name: "Gift Campaigns | O2Suite",
    },
    {
        path: "/gift/view-campaign-details/:id",
        meta: { title: "Gift Campaign Details | O2Suite" },
        component: GiftCampaignDetails,
        name: "Gift Campaign Details | O2Suite",
    },
    {
        path: "/gift/rules/:id",
        meta: { title: "Gift Rules | O2Suite" },
        component: GiftRules,
        name: "Gift Rules | O2Suite",
    },
    {
        path: "/gift/categories/:id",
        meta: { title: "Gift Categories N SubCategories | O2Suite" },
        component: GiftCategoriesNSubCategories,
        name: "Gift Categories N SubCategories | O2Suite",
    },
    {
        path: "/gift/allotments/:id",
        meta: { title: "Gift Allotments | O2Suite" },
        component: GiftAllotments,
        name: "Gift Allotments | O2Suite",
    },
    {
        path: "/gift/registrations/:id",
        meta: { title: "Gift Registrations | O2Suite" },
        component: GiftRegistrations,
        name: "Gift Registrations | O2Suite",
    },
    {
        path: "/gift/:code",
        meta: { title: "Register for a Gift | O2Suite" },
        component: RegisterForGift,
        name: "Register for a Gift | O2Suite",
    },
    {
        path: "/delivery-commitment/add",
        meta: { title: "Add New Delivery Commitment | O2Suite" },
        component: AddDeliveryCommitment,
        name: "Add New Delivery Commitment | O2Suite",
    },
    {
        path: "/delivery-commitment/preferred",
        meta: { title: "Delivery Commitments Preferred Today | O2Suite" },
        component: PreferredTodayDeliveryCommitments,
        name: "Delivery Commitments Preferred Today | O2Suite",
    },
    {
        path: "/delivery-commitment/confirmed",
        meta: { title: "Delivery Commitments Confirmed Today | O2Suite" },
        component: ConfirmedTodayDeliveryCommitments,
        name: "Delivery Commitments Confirmed Today | O2Suite",
    },
    {
        path: "/delivery-commitment/manage",
        meta: { title: "Delivery Commitments List | O2Suite" },
        component: DeliveryCommitmentsList,
        name: "Delivery Commitments List | O2Suite",
    },
    {
        path: "/delivery-commitment/view/:id",
        meta: { title: "Delivery Commitment Details | O2Suite" },
        component: DeliveryCommitmentDetails,
        name: "Delivery Commitment Details | O2Suite",
    },
    {
        path: "/visitor-log/create",
        meta: { title: "Create Visitor Log | O2Suite" },
        component: CreateVisitorLog,
        name: "Create Visitor Log | O2Suite",
    },
    {
        path: "/visitor-log/manage",
        meta: { title: "Visitors Logs | O2Suite" },
        component: VisitorLogs,
        name: "Visitors Logs | O2Suite",
    },
    {
        path: "/visitor-log/view/:id",
        meta: { title: "Visitor Log Entry | O2Suite" },
        component: VisitorLog,
        name: "Visitor Log Entry | O2Suite",
    },
    {
        path: "/employee/profile/view/:id",
        meta: { title: "Employee Profile | O2Suite" },
        component: EmployeeProfile,
        name: "Employee Profile | O2Suite",
    },
    {
        path: "/discount-requests",
        meta: { title: "Manage Discount Requests | O2Pulse" },
        component: DiscountRequests,
        name: "Manage Discount Requests | O2Pulse",
    },
    {
        path: "/pending-discount-requests",
        meta: { title: "Manage Pending Discount Requests | O2Pulse" },
        component: PendingDiscountRequests,
        name: "Manage Pending Discount Requests | O2Pulse",
    },
    //Reports
    {
        path: "/reports/gatepass-status-report",
        meta: { title: "Gatepass Status Report | O2CRM" },
        component: GatepassStatusReport,
        name: "Gatepass Status Report | O2CRM",
    },
    {
        path: "/reports/turnaway-status-report",
        meta: { title: "Turnaway Status Report | O2CRM" },
        component: TurnawayStatusReport,
        name: "Turnaway Status Report | O2CRM",
    },
    {
        path: "/reports/delivery-status-report",
        meta: { title: "Delivery Status Report | O2Delivery" },
        component: DeliveryStatusReport,
        name: "Delivery Status Report | O2Delivery",
    },
    {
        path: "/reports/service-status-report",
        meta: { title: "Service Status Report | O2Care" },
        component: ServiceStatusReport,
        name: "Service Status Report | O2Care",
    },
    {
        path: "/reports/service-category-report",
        meta: { title: "Service Category Report | O2Care" },
        component: ServiceCategoryReport,
        name: "Service Category Report | O2Care",
    },
    {
        path: "/reports/hourly-sales-report/:branch?/:from_date?/:to_date?",
        meta: { title: "Hourly Sales Report | O2CRM" },
        component: HourlySalesReport,
        name: "Hourly Sales Report | O2CRM",
    },
    {
        path: "/reports/branchwise-hourly-sales-report",
        meta: { title: "Branchwise Hourly Sales Report | O2CRM" },
        component: BranchwiseHourlySalesReport,
        name: "Hourly Sales Report | O2CRM",
    },
    {
        path: "/reports/detailed-hourly-sales-report",
        meta: { title: "Detailed Hourly Sales Report | O2CRM" },
        component: DetailedHourlySalesReport,
        name: "Detailed Hourly Sales Report | O2CRM",
    },
    {
        path: "/reports/zonewise/daily-sales-value",
        meta: { title: "Daily Sales - Zonewise | O2Suite" },
        component: DailyZonewiseSales,
        name: "Daily Sales Zonewise | O2Suite",
    },
    {
        path: "/reports/branchwise/daily-sales-value",
        meta: { title: "Daily Sales - Branchwise | O2Suite" },
        component: DailyBranchwiseSales,
        name: "Daily Sales Branchwise | O2Suite",
    },
    {
        path: "/reports/branchwise/daily-division-value/:branch?/:from?/:to?",
        meta: { title: "Daily Branch Sales - Divisionwise | O2Suite" },
        component: DailyDivisionwiseBranchSales,
        name: "Daily Sales Divisionwise | O2Suite",
    },
    {
        path: "/reports/branchwise/daily-category-value/:branch?/:from?/:to?",
        meta: { title: "Daily Branch Sales - Categorywise | O2Suite" },
        component: DailyCategorywiseBranchSales,
        name: "Daily Sales Categorywise | O2Suite",
    },
    {
        path: "/reports/branchwise/daily-product-value",
        meta: { title: "Daily Branch Sales - Productwise | O2Suite" },
        component: DailyProductwiseBranchSales,
        name: "Daily Sales Productwise | O2Suite",
    },
    {
        path: "/reports/salespersonwise/daily-sales-value/:branch?/:from?/:to?",
        meta: { title: "Daily Sales - Salesperson | O2Suite" },
        component: DailySalespersonwiseSales,
        name: "Daily Sales Salesperson | O2Suite",
    },
    {
        path: "/reports/stock/transfers-report",
        meta: { title: "Stock Transfer Report | O2Suite" },
        component: StockTransferReport,
        name: "Stock Transfer Report | O2Suite",
    },
    {
        path: "/reports/payments/general-report/:receipt?",
        meta: { title: "General Report - Payments | O2Suite" },
        component: PaymentsGeneralReport,
        name: "General Report - Payments | O2Suite",
    },

    //Intercompany
    {
        path: "/inter-company/purchase-orders",
        meta: { title: "Purchase Orders | Inter-Company" },
        component: InterCompanyPurchaseOrders,
        name: "Purchase Orders | Inter-Company",
    },
    {
        path: "/inter-company/grpo",
        meta: { title: "GRPOs | Inter-Company" },
        component: InterCompanyGRPO,
        name: "GRPOs | Inter-Company",
    },
    {
        path: "/inter-company/invoices",
        meta: { title: "List Invoices  | Inter-Company" },
        component: InterCompanyInvoices,
        name: "Invoices | Inter-Company",
    },
    //stock transfer
    {
        path: "/stock-transfer/bulk",
        meta: { title: "Bulk Stock Transfer  | Inter-Company" },
        component: BulkStockTransfer,
        name: "Bulk Stock Transfer | Inter-Company",
    },
    //erp reports
    {
        path: "/erp-reports/sync-history",
        meta: { title: "Sync History  | ERP Reports" },
        component: ERPSyncHistory,
        name: "Sync History | ERP Reports",
    },
    {
        path: "/erp-reports/sales-reports-list",
        meta: { title: "Sales Reports List | ERP Reports" },
        component: ERPSalesReportsList,
        name: "Sales Reports List | ERP Reports",
    },
    {
        path: "/erp-reports/sales-report/",
        meta: { title: "Sales Report  | ERP Reports" },
        component: ERPSalesReport,
        name: "Sales Report | ERP Reports",
    },
    {
        path: "/erp-reports/stock-reports-list",
        meta: { title: "Stock Reports List | ERP Reports" },
        component: ERPStockReportsList,
        name: "Stock Reports List | ERP Reports",
    },
    {
        path: "/erp-reports/stock-report/:id",
        meta: { title: "Stock Report  | ERP Reports" },
        component: ERPStockReport,
        name: "Stock Report | ERP Reports",
    },
    //expensing
    {
        path: "/request-petty-cash",
        meta: { title: "Request Petty Cash | Expensing" },
        component: RequestPettyCash,
        name: "Request Petty Cash | Expensing",
    },
    //stock lookup
    {
        path: "/home-stock-list",
        meta: { title: "Home Stock List | Stock-Lookup" },
        component: HomeStockList,
        name: "Home Stock List | Stock-Lookup",
    },
    {
        path: "/home-stock-lookup",
        meta: { title: "Home Stock Lookup | Stock-Lookup" },
        component: HomeStockLookup,
        name: "Home Stock Lookup | Stock-Lookup",
    },
    {
        path: "/other-branch-stock-lookup",
        meta: { title: "Other Zonal Stock Lookup | Stock-Lookup" },
        component: OtherBranchStockLookup,
        name: "Other Zonal Stock Lookup | Stock-Lookup",
    },
    {
        path: "/group-stock-lookup",
        meta: { title: "Group Stock Lookup | Stock-Lookup" },
        component: GroupStockLookup,
        name: "Group Stock Lookup | Stock-Lookup",
    },
    //hr
    {
        path: "/profile-image-uploads",
        meta: { title: "Profile Image Uploads | O2HR" },
        component: ProfileImageUploads,
        name: "Profile Image Uploads | O2HR",
    },
    {
        path: "/uploads/attendance-data",
        meta: { title: "Upload Attendance Data | O2HR" },
        component: UploadAttendanceData,
        name: "Upload Attendance Data | O2HR",
    },
    //auth and support
    {
        path: "/user-profile/:user_id?/:lead_profile_id?/:phone?",
        meta: { title: "User Profile | O2Suite::Greydesk" },
        component: UserProfile,
        name: "User Profile | O2Suite::Greydesk",
    },
    {
        path: "/support-tickets",
        meta: { title: "Support Tickets | AppSupport" },
        component: SupportTickets,
        name: "Support Tickets | User",
    },
    {
        path: "/settings",
        meta: { title: "Settings | AppSupport" },
        component: Settings,
        name: "Settings | User",
    },

    // Misc Routes
    {
        path: "/EmptyCanvas",
        component: ExampleComponent,
    },
    {
        path: "*",
        component: NoData,
    },
];

const router = new VueRouter({
    mode: "history",
    routes, // short for `routes: routes`
    linkActiveClass: "active",
});

export default router;
